import api from "../../api"
const state = {
  checkIsLogin: false,
  signed: false,
  signerror: '',
  token: null,
  account: null
}

const mutations = {
  async CHECK_LOGIN (state, { payload }) {
    state.checkIsLogin = true
    state.token = payload.token || null
  },
  LOGIN_FINISH (state, { payload }) {
    console.log('LOGIN_FINISH', payload)
    state.checkIsLogin = false
    state.signed = payload.signed || false
    state.account = payload.account || null
    state.token = payload.token || null
    if (payload.token) {
      localStorage.token = payload.token
    }
  },
  async LOGIN (state, { payload }) {
    state.signerror = ''
    try {
      const res = await api.signInByPassword(payload)
      const data = res.data
      if (data.ok) {
        this.commit('LOGIN_FINISH', { payload: {
          signed: true,
          account: data.result,
          token: data.token
        } })
      } else {
        this.commit('LOGIN_ERROR', data.err)
        setTimeout(() => {
          this.commit('LOGIN_ERROR', '')
        }, 100)
      }
    } catch (e) {
      console.log(e)
    }
  },
  LOGIN_ERROR (state, payload) {
    state.signerror = payload
  },
  // LOGIN_FINISH (state, { payload }) {
  //   state.signed = true
  //   state.account = payload
  //   console.log(state)
  // },
  LOGOUT (state, { payload }) {
    state.signed = false
    state.account = null
    state.token = null
  },
}

const actions = {
  checkLogin({ commit }, payload) {
    // do something async
    commit('CHECK_LOGIN', {
      payload: payload
    })
  },
  loginFinish({ commit }, payload) {
    // do something async
    commit('LOGIN_FINISH', {
      payload: payload
    })
  },
  login({ commit }, payload) {
    // do something async
    commit('LOGIN', {
      payload: payload
    })
  },
  loginError ({ commit }, err) {
    // do something async
    commit('LOGIN_ERROR', err)
  },
  logout({ commit }, payload) {
    // do something async
    commit('LOGOUT', {
      payload: payload
    })
  },
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/LoginInfo.js